<div class="card mb-2" (mouseover)="mouseIn()" (mouseleave)="mouseOut()" style="width: 25rem; max-width: 100% !important">
  <div class="card-body">
    <div class="card-title" *ngIf="!editing_involvement && involvement">
      <span *ngIf="hovering">
        <div class="btn-group btn-group-sm">
          <button [disabled]="deletingInvolvement" title="Edit contact" (click)="editInvolvement()" tooltip="Edit contact" type="button" style="cursor: pointer" class="btn btn-outline-primary btn-sm"><i class="fas fa-pencil-alt"></i></button>
          <button [disabled]="deletingInvolvement" title="Remove contact" (click)="deleteInvolvementModal(delete_involvement_modal)" tooltip="Remove contact" type="button" style="cursor: pointer" class="btn btn-outline-danger btn-sm"><i class="fas fa-minus-circle"></i></button>
        </div>
      </span>
      <a [href]="'/contacts/' + involvement.contact_id" [innerHTML]="involvement.display_name | safeHtml"></a>&nbsp;<small class="text-muted">({{ involvement.roles_str }})</small>
    </div>
    <p class="card-text" *ngIf="!editing_involvement && involvement">
      <app-badge badgeType="primary" *ngIf="involvement.include_spouse">Includes Spouse</app-badge><span *ngIf="involvement.include_spouse">&nbsp;&nbsp;</span><app-badge badgeType="success" *ngIf="involvement.include_employer">Includes Employer</app-badge
      ><span *ngIf="involvement.include_spouse || involvement.include_employer">&nbsp;&nbsp;</span><app-badge badgeType="info" *ngIf="involvement.use_email">Use email</app-badge><span *ngIf="involvement.include_spouse || involvement.include_employer || involvement.use_email">&nbsp;&nbsp;</span
      ><app-badge badgeType="info" *ngIf="involvement.allow_phone_text">Allow phone text</app-badge>
      <br *ngIf="involvement.include_spouse || involvement.include_employer" />
      <span class="d-block" *ngIf="involvement.addressPresent">
        <span [innerHTML]="involvement.full_address | safeHtml"></span>&nbsp;&nbsp;
        <a href="javascript: void(0)" title="Prepare an envelope for this contact" tooltip="Prepare an envelope for this contact" (click)="createOutgoingEnvelope(involvement.id, involvement.address_id)"><i class="fas fa-envelope"></i></a>
        &nbsp;
        <a target="_blank" rel="noopener noreferrer" title="Show this address on Google Maps" tooltip="Show this address on Google Maps" [href]="googleMapsLocationUrl(involvement.address_simple)"><i class="fas fa-map-marker-alt"></i></a>
      </span>
      <span *ngIf="involvement.phone_number" class="d-block"
        ><a appPhoneCallBilling [phoneCallContactName]="involvement.contact_name || ''" [href]="'tel:' + involvement.phone_number" title="Call {{ involvement.phone_number }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ involvement.phone_number }}</a><span *ngIf="involvement.phone_extension">&nbsp;X&nbsp;{{ involvement.phone_extension }}</span></span
      >
      <span *ngIf="involvement.email" class="d-block"
        ><a [href]="'mailto:' + involvement.email">{{ involvement.email }}</a></span
      >
      <span class="d-block" *ngIf="involvement.ssn && matter_type_name == 'Social Security'">SSN# {{ involvement.ssn }}</span>
      <span class="d-block text-muted font-italic" style="font-size: 85%">{{ involvement.notes }}</span>
      <span class="d-block" *ngIf="involvement.vendor_account_number">Account # {{ involvement.vendor_account_number }}</span>
      <span *ngIf="involvement.vendor_id" style="font-size: 90%">
        <a class="text-info" routerLink="/to_be_paids" [queryParams]="{ contact_id: involvement.contact_id, matter_id: involvement.matter_id, vendor_id: involvement.vendor_id }">To be paids</a>
        <br />
      </span>
      <button class="btn btn-sm btn-link" style="cursor: pointer" (click)="showAdditionalInfo()" type="button"><i [class]="'fa ' + (more_info_expanded ? 'fa-minus-circle' : 'fa-plus-circle')"></i>&nbsp;Additional Info</button>
      <span class="d-block pl-5" style="font-size: 85%" *ngIf="more_info_expanded">
        <h6>Additional Contact Info</h6>
        <p *ngIf="!additional_info" class="text-center">
          <i class="fas fa-spinner fa-pulse"></i>
        </p>
        <p *ngIf="additional_info">
          <span *ngIf="additional_info.is_person && additional_info.ssn">
            SSN# {{ additional_info.ssn }}
            <br />
          </span>
          <span *ngIf="!additional_info.is_person && additional_info.ein">
            EIN: {{ additional_info.ein }}
            <br />
          </span>
          <span *ngIf="additional_info.dob">
            Date of Birth: {{ additional_info.dob }}
            <br />
          </span>
          <span *ngIf="additional_info.dod">
            Date of Death: {{ additional_info.dod }}
            <br />
          </span>
          <span *ngIf="additional_info.fax">
            Fax Number {{ additional_info.fax }}
            <br />
          </span>
          <span *ngFor="let address of additional_info.addresses">
            <span [innerHTML]="address.full_address | safeHtml"></span>&nbsp;&nbsp;
            <a href="javascript: void(0)" title="Prepare an envelope for this contact" tooltip="Prepare an envelope for this contact" (click)="createOutgoingEnvelope(involvement.id, address.id)"><i class="fas fa-envelope"></i></a>
            &nbsp;
            <a target="_blank" rel="noopener noreferrer" title="Show this address on Google Maps" tooltip="Show this address on Google Maps" [href]="googleMapsLocationUrl(address.simple_address)"><i class="fas fa-map-marker-alt"></i></a>
            &nbsp;
            <small class="text-muted">({{ address.address_types.join(', ') }})</small>
            <br />
          </span>
          <span *ngFor="let email of additional_info.emails">
            <a [href]="'mailto:' + email">{{ email }}</a>
            <br />
          </span>
          <span class="d-block" *ngIf="additional_info.relationships.length > 0">
            <h6>Relations</h6>
            <span class="d-block" *ngFor="let relation of additional_info.relationships">
              <a [href]="'/contacts/' + relation.contact_id">{{ relation.display_name }}</a
              >&nbsp;<small class="text-muted">({{ relation.roles.join(', ') }})</small>
              <span class="d-block" *ngIf="relation.address">
                <span [innerHTML]="relation.address.full_address | safeHtml"></span>&nbsp;&nbsp;
                <a href="javascript: void(0)" title="Prepare an envelope for this contact" tooltip="Prepare an envelope for this contact" (click)="createOutgoingEnvelope(relation.id, relation.address.id)"><i class="fas fa-envelope"></i></a>
                &nbsp;
                <a target="_blank" rel="noopener noreferrer" title="Show this address on Google Maps" tooltip="Show this address on Google Maps" [href]="googleMapsLocationUrl(relation.address.simple_address)"><i class="fas fa-map-marker-alt"></i></a>
              </span>
              <span *ngIf="relation.phone" class="d-block"><a appPhoneCallBilling [phoneCallContactName]="relation.name || ''" [href]="'tel:' + relation.phone" title="Call {{ relation.phone }}"><i class="fas fa-phone fa-xs"></i>&nbsp;{{ relation.phone }}</a></span>
              <span *ngIf="relation.email" class="d-block">
                <a [href]="'mailto:' + relation.email">{{ relation.email }}</a>
              </span>
              <span class="d-block text-muted font-italic" style="font-size: 85%">{{ relation.notes }}</span>
            </span>
          </span>
        </p>
      </span>
    </p>
    <app-involvement-form *ngIf="editing_involvement" (formResult)="involvementFormResult($event)" [involvement_id]="involvement.id"></app-involvement-form>
  </div>
</div>
<ng-template #delete_involvement_modal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title text-danger">Delete involvement</h5>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>Confirm contact ({{ involvement.display_name }}) removal from this matter ?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="c('delete')">Confirm delete</button>
    <button type="button" class="btn btn-outline-secondary" (click)="c('Close click')">Cancel</button>
  </div>
</ng-template>
